import useOnlineStatus from '../../hooks/useOnlineStatus';

const OfflineBanner = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div
      role="status"
      className="fixed top-0 inset-x-0 z-[120] bg-amber-500 text-white text-xs sm:text-sm font-semibold text-center py-2 px-4 shadow-md"
    >
      <i className="fas fa-triangle-exclamation mr-2" aria-hidden="true"></i>
      You're offline. Some data may be out of date and changes may not save.
    </div>
  );
};

export default OfflineBanner;
